<template>
	<div class="title-sidebar__title-with-poster">
		<div class="title-sidebar__title-with-poster__title-text">
			<slot></slot>

			<TitleDetailChartInfoV1
				v-if="showChartInfo && streamingChartInfo"
				:streamingChartInfo="streamingChartInfo"
			/>

			<TitleDetailSideInfos
				v-else
				:title="title"
				:hasStreamingChart="!!(showChartInfo && streamingChartInfo)"
				:itemLimit="2"
				:itemStartAt="0"
				:aboveTheFold="true"
			/>
		</div>
		<div class="title-sidebar__title-with-poster__poster">
			<PictureComp :alt="titleName" :imageUrl="imgSrc" image-profile="poster_global" v-if="imgSrc" />
			<div class="place-holder__container" v-else>
				<img src="/appassets/img/poster-placeholder.png" />
				<div class="title_container">
					<span class="title">{{ titleName }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { StreamingChartInfo } from '@/@types/graphql-types';

import TitleDetailChartInfoV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailChartInfoV1.vue';
import TitleDetailSideInfos from '@/pages/titleDetailV1/v1/sidebar/TitleDetailSideInfos.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { thumborFilter, ThumborOptions } from '@/filters/thumbor';
import { TitleDetail } from '@/interfaces/title-details-graphql';

const props = defineProps<{
	showChartInfo: boolean;
	streamingChartInfo?: StreamingChartInfo | null;
	title: TitleDetail;
}>();

const titleName = computed(() => {
	if (props.title.__typename === 'Season') {
		return props.title.show.content.title + ' - ' + props.title.content.title;
	}
	return props.title.content.title;
});

const imgSrc = computed(() => {
	return thumborFilter()({
		url: props.title.content.posterUrl,
		imageType: 'poster_global',
	} as ThumborOptions);
});
</script>

<style lang="scss" scoped>
.title-sidebar {
	&__title-with-poster {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&__title-text {
			display: flex;
			flex-direction: column;
			max-width: 220px;
		}

		&__poster {
			width: 144px;
			height: 216px;
			border-radius: 8px;
			overflow: hidden;
			margin: 32px 0px 24px 0px;
		}
	}
	.place-holder__container {
		position: relative;

		.title_container {
			z-index: 2;
			position: absolute;
			bottom: 10px;
			left: 0;
			right: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.title {
			font-size: 14px;
			color: #c6c8cd;
			font-weight: 600;
			text-align: center;
			padding: 0 10px;
		}
	}
}
</style>
